export const GET_RECEIPTS = 'GET_RECEIPTS';
export const FETCH_RECEIPT_COUNT = 'FETCH_RECEIPT_COUNT';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const UPDATE_SEARCH = 'UPDATE_SEARCH_RECEIPT';
export const UPDATE_PAGE = 'UPDATE_PAGE_RECEIPT';
